import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import ConfirmationDialog from '../ConfirmationDialog';

const FormEditTicket = () => {
  const [ticket_id, setTicketId] = useState("");
  const [description, setDesc] = useState("");
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");
  const [time_open, setTimeOpen] = useState("");
  const [time_close, setTimeClose] = useState("");
  const [contracts, setContract] = useState([]);
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  const { id, idproduct, idclient } = useParams();
  const [isDialogStatusOpen, setDialogStatusOpen] = useState(false);
  const [isDialogStatusClose, setDialogStatusClose] = useState(false);
  const [isDialogStatusRepair, setDialogStatusRepair] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  // dialog open
  const handleConfirmStatusOpen = async (e) => {
    e.preventDefault();
    try {
      await axios.patch(`${API_BASE_URL}/tickets/${id}`, {
        headers: {
            'X-API-Key': API_KEY
        },
        status: status,
        notes: notes,
      });
      navigate("/tickets");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
    setDialogStatusOpen(false);
  };
  const handleModalCloseStatusOpen = () => {
    setDialogStatusOpen(false);
  };
  // dialog close
  const handleConfirmStatusClose = async (e) => {
    e.preventDefault();
    try {
      await axios.patch(`${API_BASE_URL}/tickets/${id}`, {
        headers: {
            'X-API-Key': API_KEY
        },
        status: status,
        notes: notes,
      });
      navigate("/tickets");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
    setDialogStatusClose(false);
  };
  const handleModalCloseStatusClose = () => {
    setDialogStatusClose(false);
  };
  // dialog repair
  const handleConfirmStatusRepair = async (e) => {
    e.preventDefault();
    try {
      await axios.patch(`${API_BASE_URL}/tickets/${id}`, {
        headers: {
            'X-API-Key': API_KEY
        },
        status: status,
        notes: notes,
        description: description,
        contracts: contracts,
      });
      navigate("/tickets");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
    setDialogStatusRepair(false);
  };
  const handleModalCloseStatusRepair = () => {
    setDialogStatusRepair(false);
  };
  const handleTimeCloseChange = (event) => {
    setTimeClose(event.target.value);
  };
  const handleTimeOpenChange = (event) => {
    setTimeOpen(event.target.value);
  };
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
    const now = new Date();
    // Adjust for the local timezone offset to prevent UTC conversion issues
    const timezoneOffsetMs = now.getTimezoneOffset() * 60000;
    const localDatetime = new Date(now - timezoneOffsetMs);
    // Format to the required "YYYY-MM-DDTHH:MM" string format
    const formattedDatetime = localDatetime.toISOString().slice(0, 16);
    setTimeClose(formattedDatetime);
    console.log(formattedDatetime);
  };

  useEffect(() => {
    const getTicketById = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/tickets/${id}`, {
          headers: {
            'X-API-Key': API_KEY
          },
        });

        if(response.data.status==="OPEN" || response.data.status==="CLOSED"){
          const startdate = new Date(response.data.time_open);
          startdate.setMinutes(startdate.getMinutes() - startdate.getTimezoneOffset());
          const starttime = startdate.toISOString().slice(0,16);
          setTimeOpen(starttime);
        }

        if(response.data.status==="CLOSED"){
          const enddate = new Date(response.data.time_close);
          enddate.setMinutes(enddate.getMinutes() - enddate.getTimezoneOffset());
          const endtime = enddate.toISOString().slice(0,16);
          setTimeClose(endtime);
        }

        setTicketId(response.data.ticket_id);
        setDesc(response.data.description);
      
        setStatus(response.data.status);
        setNotes(response.data.notes);
      
        const idproduct = response.data.productId;
        const idclient = response.data.clientId;
        const res = await axios.get(
            `${API_BASE_URL}/contractclient/${idproduct}/${idclient}`, {
              headers: {
                'X-API-Key': API_KEY
              },
            }
        );
        setContract(res.data);
        //console.log(res.data);
      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    };
    getTicketById();
  }, [id, idproduct, idclient]);

  const calculateDaysDifference = (endDate) => {
    const start = new Date();
    const end = new Date(endDate);
    const timeDifference = end.getTime() - start.getTime(); // Difference in milliseconds
    const millisecondsPerDay = 1000 * 60 * 60 * 24; // Milliseconds in a day
    const daysDifference = Math.floor(timeDifference / millisecondsPerDay); // Use Math.floor for whole days
    if(daysDifference < 0){
      return <span className="tag is-danger">Expired</span>;
    }else{
      return <span className="tag is-success">Guarantee</span>;
    }  
};

  const updateTiket = async (e) => {
    e.preventDefault();
    if(status==="OPEN"){
      setDialogStatusOpen(true);
    }else if (status==="CLOSED"){
      setDialogStatusClose(true);
    }else{
      setDialogStatusRepair(true);
    }
    /**/
  };
  
  return (
    <div className="panel is-link">
      <p className="panel-heading">CHECK TICKET</p>
      <div className="card is-shadowless p-2">
        <h1 className="title is-size-5 mt-4">Product In Contract:</h1>
        <table className="table is-bordered is-striped is-fullwidth is-size-7">
            <thead>
                <tr>
                  <th style={{width: "1%"}}>No</th>
                  <th className="has-text-centered">Product</th>        
                  <th className="has-text-centered">Contract_No</th>
                  <th className="has-text-centered">Client/Customer</th>
                  <th className="has-text-centered">Address</th>
                  <th className="has-text-centered">Phone</th>                                      
                  <th className="has-text-centered">End_Guarantee</th>
                  <th className="has-text-centered">Status_Guarantee</th>
                </tr>
            </thead>
            <tbody>
                {contracts.map((item, index) => (
                    <tr key={item.uuid}>
                        <td>{index + 1}</td>
                        <td>{item.product.productname}</td>  
                        <td className="has-text-centered">{item.contract.contract_no}</td>
                        <td>{item.contract.client.name}</td>
                        <td>{item.contract.client.address}</td>               
                        <td>{item.contract.client.phone}</td>                                         
                        <td className="has-text-centered">{item.contract.end_guarantee}</td>
                        <td className="has-text-centered">{calculateDaysDifference(item.contract.end_guarantee)}</td>
                    </tr>
                ))}
            </tbody>
        </table> 
        <form onSubmit={updateTiket}>
          <p className="has-text-left has-text-danger">{msg}</p>
          <div className="field columns">
            <div className="column is-half">
              <label className="label">No.Ticket</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={ticket_id}
                  onChange={(e) => setTicketId(e.target.value)}
                  disabled
                />
              </div>
            </div>            
          </div>
          <div className="field">
              <label className="label">Problem_Description</label>
              <div className="control">
                  <textarea 
                      className="textarea"
                      value={description}
                      onChange={(e) => setDesc(e.target.value)}
                      placeholder="Problem Description"
                      rows="2"
                  ></textarea>
              </div>
          </div>
          <div className="field columns">
            <div className="column is-3">
                <label className="label">Status_Ticket</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      value={status}
                      //onChange={(e) => setStatus(e.target.value)}
                      onChange={handleStatusChange}
                    >
                      <option value="OPEN">OPEN</option>
                      <option value="REPAIRED">REPAIRED</option>
                      <option value="CLOSED">CLOSED</option>
                    </select>
                  </div>
                </div>
            </div>
            <div className="column is-3">
                  <label className="label">Time_Open</label>
                  <div className="control">
                    <input className="input"
                        type="datetime-local"
                        id="time_open"
                        name="time_open"
                        value={time_open} // Controlled component
                        onChange={handleTimeOpenChange}
                    />
                  </div>
                </div>
                {status==="CLOSED" ? (
                <div className="column is-3">
                  <label className="label">Time_Close</label>
                  <div className="control">
                    <input className="input"
                        type="datetime-local"
                        id="time_close"
                        name="time_close"
                        value={time_close} // Controlled component
                        onChange={handleTimeCloseChange}
                    />
                  </div>
                </div>
                ) : (
                  <p></p>
                )}
          </div>
          
          <div className="field">
              <label className="label">Notes from Admin</label>
              <div className="control">
                  <textarea
                      className="textarea"
                      value={notes || ''}
                      onChange={(e) => setNotes(e.target.value)}
                      placeholder="Notes"
                      rows="2"
                  ></textarea>
              </div>
          </div>
          <div className="field">
              <Link to="/tickets">
              <button className="button is-warning mr-1">
                  Cancel
              </button>
              </Link>
              <button type="submit" className="button is-success">
                  Update
              </button>
          </div>          
      </form>   
      <ConfirmationDialog
        isActive={isDialogStatusOpen}
        onClose={handleModalCloseStatusOpen}
        onConfirm={handleConfirmStatusOpen}
        title="Confirm Update Ticket"
        message="This ticket status is still OPEN, are you sure you want to continue?"
      />
      <ConfirmationDialog
        isActive={isDialogStatusClose}
        onClose={handleModalCloseStatusClose}
        onConfirm={handleConfirmStatusClose}
        title="Confirm Update Ticket"
        message="Are you sure this ticket will be closed?"
      />
      <ConfirmationDialog
        isActive={isDialogStatusRepair}
        onClose={handleModalCloseStatusRepair}
        onConfirm={handleConfirmStatusRepair}
        title="Confirm Update Ticket"
        message="Are you sure this Ticket wants to be continued to Repair?"
      />                  
    </div>
  </div>
  );
};

export default FormEditTicket;